import { render, staticRenderFns } from "./Inhabitant.vue?vue&type=template&id=08a3eb5c&"
import script from "./Inhabitant.vue?vue&type=script&lang=js&"
export * from "./Inhabitant.vue?vue&type=script&lang=js&"
import style0 from "./Inhabitant.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports